import {type GuidType} from '../../values/generic-type-definitions'
import {type Vessel} from './vessel-selector.types'
import {FlexAlignments, FlexCol} from '../base/flexbox.styled'
import {useState, type JSX} from 'react'
import Styled from './vessel-selector.styled'

export interface VesselSelectorProps {
    label?: string
    description?: string
    placeholder?: string
    vesselsWithTags: Vessel[]
    selectedVesselIds: Set<GuidType>
    isDefaultExpanded?: boolean
    isDisabled?: boolean
    onChange: (selectedVesselIds: Set<GuidType>) => void
    className?: string
    id?: string
    granularMode?: boolean
}

export function VesselSelector(props: VesselSelectorProps): JSX.Element {
    const [filter, setFilter] = useState<string>('')

    return (
        <FlexCol
            alignItems={FlexAlignments.Stretch}
            spacing={1}
            className={props.className}
            data-disabled={props.isDisabled}
        >
            <Styled.SearchField
                aria-label="Vessel Selector Search"
                onChange={setFilter}
                isDisabled={props.isDisabled}
            >
                {props.label && <Styled.Label>{props.label}</Styled.Label>}
                <Styled.Input placeholder={props.placeholder ?? 'Search vessels or tags...'} />
                <Styled.CrossButton />
                {props.description && (
                    <Styled.Text slot="description">{props.description}</Styled.Text>
                )}
            </Styled.SearchField>
            <Styled.VesselSelectorTree
                vesselsWithTags={props.vesselsWithTags}
                selectedVesselIds={props.selectedVesselIds}
                onChange={props.onChange}
                selectionMode="multiple"
                filter={filter}
                aria-label="Vessel Selector Tree"
                isDefaultExpanded={props.isDefaultExpanded}
                isDisabled={props.isDisabled}
                granularMode={props.granularMode}
            />
        </FlexCol>
    )
}
